// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeBanner-homeBannerForm-hEq4E {
    position: relative;
}

.homeBanner-formWrap-StYT0 {
    color: var(--secondary-foreground);
    position: relative;
    background: var(--background-primary);
    padding: 30px;
    border-radius: 15px;
    max-width: 450px;
    -webkit-box-shadow: 1px 5px 10px var(--primary-box-shadow);
            box-shadow: 1px 5px 10px var(--primary-box-shadow);
    z-index: 3;
}

.homeBanner-sliderImage-wSdyx {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
}

@media screen and (min-width:1200px) {
    .homeBanner-sliderImage-wSdyx {
        height: 120%;
    }
}

@media screen and (max-width:767px) {
    .homeBanner-formWrap-StYT0 {
        padding: 20px;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/homeSliderBanner/homeBanner.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,0DAAkD;YAAlD,kDAAkD;IAClD,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;AACrB;;AAEA;IACI;QACI,YAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;AAEJ","sourcesContent":[".homeBannerForm {\n    position: relative;\n}\n\n.formWrap {\n    color: var(--secondary-foreground);\n    position: relative;\n    background: var(--background-primary);\n    padding: 30px;\n    border-radius: 15px;\n    max-width: 450px;\n    box-shadow: 1px 5px 10px var(--primary-box-shadow);\n    z-index: 3;\n}\n\n.sliderImage {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n@media screen and (min-width:1200px) {\n    .sliderImage {\n        height: calc(100% + 20%);\n    }\n}\n\n@media screen and (max-width:767px) {\n    .formWrap {\n        padding: 20px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeBannerForm": `homeBanner-homeBannerForm-hEq4E`,
	"formWrap": `homeBanner-formWrap-StYT0`,
	"sliderImage": `homeBanner-sliderImage-wSdyx`
};
module.exports = ___CSS_LOADER_EXPORT___;
